import { RuntimeException1r3t0zl97011n as RuntimeException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  captureStack1fzi4aczwc4hg as captureStack,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { LinkedHashSet2tkztfx86kyx2 as LinkedHashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashSet.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { stackTraceToString2670q6lbhdojj as stackTraceToString } from '../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_platformExceptionHandlers_() {
  _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf();
  return platformExceptionHandlers_;
}
var platformExceptionHandlers_;
function get_platformExceptionHandlers() {
  _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf();
  return get_platformExceptionHandlers_();
}
var DiagnosticCoroutineContextExceptionClass;
function DiagnosticCoroutineContextException() {
  if (DiagnosticCoroutineContextExceptionClass === VOID) {
    class $ extends RuntimeException() {
      constructor(context) {
        return new.target.new_kotlinx_coroutines_internal_DiagnosticCoroutineContextException_ie0iwd_k$(context);
      }
      static new_kotlinx_coroutines_internal_DiagnosticCoroutineContextException_ie0iwd_k$(context) {
        var $this = this.new_kotlin_RuntimeException_xu1s8h_k$(toString(context));
        captureStack($this, $this.$throwableCtor_3);
        return $this;
      }
    }
    initMetadataForClass($, 'DiagnosticCoroutineContextException');
    DiagnosticCoroutineContextExceptionClass = $;
  }
  return DiagnosticCoroutineContextExceptionClass;
}
var properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx;
function _init_properties_CoroutineExceptionHandlerImpl_kt__37d7wf() {
  if (!properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx) {
    properties_initialized_CoroutineExceptionHandlerImpl_kt_qhrgvx = true;
    // Inline function 'kotlin.collections.mutableSetOf' call
    platformExceptionHandlers_ = LinkedHashSet().new_kotlin_collections_LinkedHashSet_ahyf7j_k$();
  }
}
function propagateExceptionFinalResort(exception) {
  // Inline function 'kotlin.with' call
  throwAsyncJsError(exception.message, getKClassFromExpression(exception).get_simpleName_r6f8py_k$(), stackTraceToString(exception));
  return Unit_instance;
}
function throwAsyncJsError(message, className, stack) {
  var error = new Error();
  error.message = message;
  error.name = className;
  error.stack = stack;
  if (typeof globalThis.reportError === 'function') {
    // Up-to-date browsers and some non-browser JS runtimes (Deno, Bun)
    globalThis.reportError(error);
  } else {
    // Fallback for old browsers (pre-2022), Node.js
    setTimeout(function () {
      throw error;
    }, 0);
  }
}
//region block: exports
export {
  DiagnosticCoroutineContextException as DiagnosticCoroutineContextException2e2ligokby0yu,
  get_platformExceptionHandlers as get_platformExceptionHandlers2k88c6wpwtspf,
  propagateExceptionFinalResort as propagateExceptionFinalResort3uf2dkl63idew,
};
//endregion

//# sourceMappingURL=CoroutineExceptionHandlerImpl.mjs.map
